export default {
  "b2b.prehled": "overview",
  "b2b.provozni-informace.list": "operational-information",
  "b2b.provozni-informace.detail": "operational-information/:id/detail",
  "b2b.provozni-informace.new": "operational-information/new",
  "b2b.provozni-informace.edit": "operational-information/:id/edit",
  "b2b.rezervace": "reservation",
  "b2b.rezervace.historie": "reservation/history",
  "b2b.rezervace.odbaveni": "reservation/check-in",
  "b2b.rezervace.vytvoreni": "reservation/new",
  "b2b.rezervace.casovy-plan": "reservation/timeline",
  "b2b.administrace": "administration",
  "b2b.administrace.konfiguracni-parametry":
    "administration/configuration-parameters",
  "b2b.administrace.zakaznik": "administration/customer/:ico",
  "b2b.administrace.zakaznik.smluva":
    "administration/customer/:ico/contract/:id?",
  "b2b.administrace.zakaznik.projekt":
    "administration/customer/:ico/project/:id?",
  "b2b.administrace.zakaznici": "administration/customers",
  "b2b.administrace.zdroje": "administration/resources",
  "b2b.administrace.zdroj": "administration/resource/:id?",
  "b2b.administrace.produkt": "administration/product/:id?",
  "b2b.administrace.doplnkova-sluzba": "administration/additional-service/:id?",
  "b2b.zadosti.detail": "request/:id",
  "b2b.unauthorized": "insufficient-rights"
};
